module.exports = __webpack_public_path__ + "static/media/test6_3.6c3d6960.png";